import React from 'react' 
import Logo from '../../assets/DagoraLogoLarge.webp'
import {Link} from 'react-router-dom'

function HeaderHome() {
    return(
        <header className="flex items-center justify-between bg-DAgora-Blue md:p-8 z-50">
            <div className="flex items-center">
            <Link to="/">
                <img src={Logo} height={80} width={80} />
            </Link>
            </div>
            <div className="flex items-center">
                <Link to="/about" className="text-white md:px-4 px-2 md:text-2xl hover:text-DAgora-Pink">About</Link>
                <Link to="/contactus" className="text-white md:px-4 px-2 md:text-2xl hover:text-DAgora-Pink">Contact us</Link>
            </div>
        </header>
    )
}


export default HeaderHome